import React from "react";
import { Tooltip } from "@src/common/components";
import { ChatBubbleLeftIcon } from "@heroicons/react/24/outline";
import { Shipment } from "@api/graphql/generated/generated-types";
import { getInternalNotePreview } from "../utils/shipmentNoteUtils";

interface DriverNoteIndicatorProps {
  shipment: Shipment | undefined;
}

export function DriverNoteIndicator({ shipment }: DriverNoteIndicatorProps) {
  if (!shipment?.stops?.length) return null;

  const stopNotes = shipment.stops
    .map((stop) => stop.driverNote)
    .filter((note): note is string => Boolean(note));

  if (!stopNotes.length) return null;

  const firstNote = stopNotes[0];
  const hasMultipleNotes = stopNotes.length > 1;

  return (
    <Tooltip
      content={
        hasMultipleNotes
          ? `${stopNotes
              .map((note) => getInternalNotePreview(note))
              .join(", ")}`
          : getInternalNotePreview(firstNote)
      }
      placement="bottom"
    >
      <div className="flex items-center gap-1 mt-1">
        <ChatBubbleLeftIcon className="h-4 w-4 text-yellow-300" />
        <span className="text-xs text-yellow-300 truncate font-bold">
          {hasMultipleNotes
            ? `${stopNotes.length} notes`
            : getInternalNotePreview(firstNote)}
        </span>
      </div>
    </Tooltip>
  );
}
